import React, { useState } from 'react';
import './header.css';
import ai from '../../assets/ai.png';
import axios from 'axios';
import queryString from 'query-string';
import fetchJsonp from 'fetch-jsonp';

const Header = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const submitContactHandle = async (e) => {
    e.preventDefault();
    const email = e.target[0].value;
    const name = e.target[1].value;
    const phone = e.target[2].value;
    const query = queryString.stringify([email, name, phone]);
    const endpoint =
      `https://gmail.us21.list-manage.com/subscribe/post?${process.env.MAIL_CHIMP_TOKEN}`.replace(
        '/post?',
        '/post-json?'
      ) +
      '&' +
      query;
    try {
      const response = await fetchJsonp(endpoint, {
        jsonpCallback: 'c',
      });
      const resData = await response.json();
    } catch (error) {}

    // axios({
    //   method: 'post',
    //   url: 'https://porfolioak.herokuapp.com/contactme',
    //   headers: { 'Content-Type': 'application/json' },
    //   data: {
    //     email: email,
    //     message: message,
    //   },
    // })
    //   .then((result) => {
    //     setIsSubmitted(true);
    //   })
    //   .catch((err) => err);
  };

  return (
    <div className="gpt3__header section__padding" id="home">
      <div className="gpt3__header-content">
        <h1 className="gradient__text">H E L L O</h1>
        <p>Howdy, my name is Alex. </p>
        {/* {!isSubmitted ? ( */}
        {/* <div className="gpt3__header-content__input">
            <form
              onSubmit={(e) => submitContactHandle(e)}
              action=""
              className="gpt3__header-content__input"
            >
              <div className="gpt3__header-content__input-boxes">
                <input type="email" placeholder="Your Email Address" />
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Your Phone Number" />
              </div>
              <button type="submit">Contact</button>
            </form>
          </div>
        ) : (
          <h3 className="gpt3__header-success">
            🤩 Thank you for contacting me 🤩
          </h3>
        )} */}
      </div>
      <div className="gpt3__header-image">
        <img src={ai} alt="ai" />
      </div>
    </div>
  );
};

export default Header;
